import * as React from 'react';

import { IAmpProps } from '../../typings/amp';

export interface IAmpIframeProps
  extends IAmpProps,
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  src?: string;
  style?: React.CSSProperties;
  sandbox?: string;
  frameborder?: string;
}

const AmpIframe: React.FC<IAmpIframeProps> = ({
  src = '',
  width = '100',
  height = '100',
  layout = 'fixed',
  dataBlockOnConsent,
}) => (
  <amp-iframe
    sandbox="allow-scripts allow-same-origin allow-popups allow-presentation"
    width={width}
    height={height}
    style={{ height }}
    layout={layout}
    src={src}
    data-block-on-consent={dataBlockOnConsent ? '' : undefined}
    frameborder="0"
  />
);

export default AmpIframe;
